import { render } from "./BaseButton.vue?vue&type=template&id=c6eec220&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=c6eec220&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c6eec220"

export default script